<template>
  <div class="w-full">
    <vue-dropzone
      ref="dropzone"
      id="files-dropzone"
      :options="dropzoneOptions"
      @vdropzone-success="upload_success"
      @vdropzone-error="upload_error"
    ></vue-dropzone>
  </div>
</template>
<script type="text/javascript">
import { mapState } from "vuex";
import "vue2-dropzone/dist/vue2Dropzone.min.css";

import FileAPI from "../../../api/file.js";

export default {
  props: {
    patient_id: {
      require: true,
    },
    examination_id: {
      required: false,
    },
  },

  computed: {
    ...mapState("auth", ["user"]),
    dropzoneOptions() {
      let token = document.head.querySelector('meta[name="csrf-token"]')
        .content;
      return {
        url: FileAPI.uploadURL(this.patient_id, this.examination_id),
        thumbnailWidth: 150,
        dictDefaultMessage: "<i class='cloud upload icon'></i>CARICA",
        addRemoveLinks: true,
        headers: {
          "X-CSRF-Token": token,
          Authorization: "Bearer " + (this.user ? this.user.access_token : ""),
        },
      };
    },
  },

  methods: {
    upload_success(file_element, file) {
      this.$refs.dropzone.removeFile(file_element);
      this.$store.dispatch("file/add", file);
    },
    upload_error(file_element, message, xhr) {
      this.$refs.dropzone.removeFile(file_element);
    },
    remove_file(data) {
      if (confirm("Sicuro di voler cancellare il file?")) {
        this.$store.dispatch("file/delete", {
          id: this.files[data.index].id,
        });
        this.files.splice(data.index, 1);
      }
    },
  },
};
</script>
